/* AIS hand the subscriber back with their msisdn on the query string. It is kept so the
   thank you page can build the One81 auto-login URL. */
export function readMsisdnFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const msisdn = urlParams.get('msisdn') ?? urlParams.get('MSISDN');
    if (!msisdn) return undefined;

    const digits = msisdn.replace(/\D/g, '');
    return digits || undefined;
}
